var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layou-home"},[_c('LockScreen',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModel),expression:"showModel"}]}),_c('div',{staticClass:"layou-home-top"},[_c('Topmenu',{staticClass:"layout-nav"})],1),_c('div',{staticClass:"layou-home-bottom"},[_c('div',{staticClass:"layou-home-bottom-pir"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }